module.exports = __webpack_public_path__ + "img/pdfIcon.2be243ea.png";